import { get, invoke } from "lodash";
import { ADMIN, API_URL, WHITELABEL_INSTANCE } from "../../../routes/constants";
import request from "../../../utils/request";
import { toast } from "react-toastify";
import StorageService from "../../../utils/StorageService";

export const hexToRgb = (color = "") =>
  color.startsWith("#")
    ? color
        .substring(1)
        .match(/.{2}/g)
        .map((d) => parseInt(d, 16))
        .toString()
    : color;

export function getInstance() {
  const data = {
    method: "GET",
  };
  this.setState({ loading: true });

  const requestURL = `${API_URL}${ADMIN}${WHITELABEL_INSTANCE}`;

  request(requestURL, data)
    .then((res) => {
      this.setState({ loading: false });
      if (res.status) {
        // main color
        invoke(this, "setState", {
          landingUrl: get(res, "data.frontendDomain", ""),
        });
        document.documentElement.style.setProperty(
          "--primary-color",
          get(res.data, "primaryColor", "")
        );
        document.documentElement.style.setProperty(
          "--cta-color",
          get(res.data, "appStyle.ctaColor", "")
        );
        document.documentElement.style.setProperty(
          "--app-primary-background-color",
          get(res.data, "appStyle.primaryBackgroundColor", "")
        );
        document.documentElement.style.setProperty(
          "--help-text-color",
          get(res.data, "contentStyle.helpTextColor", "")
        );

        // rgb colors

        document.documentElement.style.setProperty(
          "--help-text-color-rgb",
          hexToRgb(get(res.data, "contentStyle.helpTextColor", ""))
        );

        document.documentElement.style.setProperty(
          "--cta-color-rgb",
          hexToRgb(get(res.data, "appStyle.ctaColor", ""))
        );

        StorageService.set(
          "appPartner",
          get(res.data, "slugName") === "app" ? "beatBread" : "chordCash"
        );
      }
    })
    .catch((err) => {
      this.setState({ loading: false });
      toast.error(get(err, "message"));
    });
}
